import http from '@/request/http'
export default {
  // 首页设备类型数
  equipmentOnline: params => http.get(`/api/plugins/statistics/getDeviceCount`, params),
  equipmentOnlineNumber: params => http.get(`/api/plugins/statistics/getAlarmAndNotActiveRecordByLabel`, params),
  // 获取设备类型列表
  getDeviceTypes: params => http.get(`/api/juji/device/getDeviceTypes`, params),
  // 获取设备列表
  getDeviceListByType: params => http.get(`/api/juji/device/getDeviceListByType`, params),

  // 获取tab列表
  getSTabList: params => http.get(`/api/juji/deviceTypeAttributeTelemetry/getByTypeCategoryShowBack`, params),
  // 获取图表数据
  getSChartsData: (params, entityId, type) => http.get(`/api/juji/customerProjectAttributes/${type}/${entityId}/values/timeseries/merge`, params),
  // 获取设备信息
  getSDetailsList: (params, deviceId) => http.get(`/api/juji/deviceManage/deviceInfo/${deviceId}`, params),
  // 获取负载数据
  getSDeviceLoadData: (params) => http.get(`/api/plugins/statistics/getDeviceTelemetryValues`, params),
  // 获取报警配置列表
  getAlarmConfiguration: params => http.get(`/api/juji/alarmRules/getAlarmRules`, params),
  // 修改报警配置
  setAlarmConfiguration: (params, deviceId) => http.post(`/api/plugins/telemetry/clientscope/${deviceId}/`, params),
  /*** 报警管理 ***/
  getSAlarmsList: params => http.get(`/api/juji/alarm/getAlarmsPageList`, params),
  getSAlarmsTolData: params => http.get(`/api/juji/alarm/getAlarmsCount`, params),
  getSAlarmTypeList: params => http.get(`/api/juji/alarm/getAlarmType`, params),
  getSAlarmhandleConfirm: params => http.post(`/api/juji/alarm/setBatchConfirmation`, params),
  getSAlarmDetailsTop: params => http.get(`/api/juji/alarm/getAlarmDetailsList`, params),
  getSAlarmDetailsCharts: params => http.get(`/api/juji/alarm/getAlarmDetailsChart`, params),
  /*** 报警分析 ***/
  getSAlarmAnalysis: params => http.get(`/api/juji/alarm/getAlarmAnalysis`, params),
  getSAlarmHourTrend: params => http.get(`/api/juji/alarm/getTwentyFourHourAlarmTrend`, params),
  getSAlarmRangeTrend: params => http.get(`/api/juji/alarm/getAlarmRangeTrend`, params),
  getSAlarmAnalysisTable: params => http.get(`/api/juji/alarm/getAlarmDetailsTable`, params),



  /*** 运行时间 ***/
  // 获取运行时间列表
  getSetRuntimeList: params => http.get(`/api/juji/uptime/findUptimeSettings`, params),
  // 获取运行时间图表
  getSetRuntimeCharts: params => http.get(`/api/juji/uptime/findDeviceRuntime`, params),
  // 设置正常运行时间
  setNormalRuntime: params => http.post(`/api/juji/uptime/saveUptimeSettings`, params),
  // 删除设置正常运行时间
  deleteNormalRuntime: params => http.get(`/api/juji/uptime/deleteUptimeSettings`, params),

  /*** 维修记录 ***/
  devicesMaintenance: params => http.get(`/api/juji/deviceManage/getRepairRecords`, params),

  /*** 设备管理 ***/
  DMGetByName: params => http.get(`/api/deviceProfileExtra/getByName`, params),   //设备参数列表
  DMFindWorkOrderList: params => http.get(`/api/odoo/workOrder/findWorkOrderList`, params),   //工单记录
  DMGetAlarmsPageList: params => http.get(`/api/juji/alarm/getAlarmsPageList`, params),   //报警记录
  DMGetHistoryTable: params => http.get(`/api/juji/deviceManage/analysisData/history/table`, params),   //历史数据
  DMGetRealtimeTable: params => http.get(`/api/juji/deviceManage/analysisData/realTime/table`, params),   //实时数据
  DMGetTimeOff: (params, deviceId) => http.get(`/api/plugins/telemetry/DEVICE/${deviceId}/values/attributes/SERVER_SCOPE`, params),   //定时关闭获取数据
  DMSetTimeOff: params => http.post(`/api/plugins/telemetry/deviceManage/closeTime/edit`, params),     //定时关闭编辑
  DMGetAlarmLevel: params => http.get(`/api/juji/device/getAlarmLevel`, params),   //预警设置，离线报警等级
  DMSetAlarmLevel: params => http.post(`/api/juji/device/updateAlarmLevel`, params),     //预警设置，离线报警等级
  DMGetAutomaticControl: (params, deviceId) => http.get(`/api/plugins/telemetry/DEVICE/${deviceId}/values/attributes`, params),   //自动控制获取参数
  DMSetAutomaticControl: (params, deviceId) => http.post(`/api/plugins/telemetry/DEVICE/${deviceId}/SHARED_SCOPE`, params),   //自动控制设置
}